/** The first validation message on a TanStack Form field. */
export function FieldError({
  errors,
}: Readonly<{ errors: readonly unknown[] }>) {
  const first = errors.find(Boolean);
  if (!first) return null;
  return <p className="text-sm text-danger-ink">{messageOf(first)}</p>;
}

function messageOf(error: unknown): string {
  if (typeof error === 'string') return error;
  if (typeof error === 'object' && error && 'message' in error) {
    return String((error as { message: unknown }).message);
  }
  return 'Check this field.';
}
